import { FormInstance } from "antd";
import { FloatNumberInput } from "../../../../../../../components/FloatNumberInput";
import { useCallback, useMemo } from "react";

type AmountInputProps = {
  form: FormInstance;
  name: string;
  calculate: (toUpdate?: { name: string; value: any }) => void;
  getDisabled: (names: string[]) => boolean;
};

export const AmountInput = ({
  form,
  name,
  calculate,
  getDisabled,
}: AmountInputProps) => {
  const disabled: boolean = useMemo(
    () => getDisabled(["interest"]),
    [getDisabled]
  );

  const inputName: string[] = useMemo(
    () => ["breakdown", `${name}Amount`],
    [name]
  );

  const onCalculate = useCallback(
    () => calculate({ name: `${name}.Amount`, value: true }),
    [calculate, name]
  );

  return (
    <FloatNumberInput
      name={inputName}
      label=""
      form={form}
      className="totals-input mb-0"
      allowNegative
      onPressEnter={onCalculate}
      disabled={disabled}
      includeThousandsSeparator
    />
  );
};
